import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Container, Loader2, ArrowLeft, Mail } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setSent(true);
      toast.success("If the account exists, a reset link has been generated.");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 px-4">
      <div className="w-full max-w-md bg-slate-900/90 border border-slate-700 rounded-lg p-8 shadow-2xl" data-testid="forgot-card">
        <div className="flex items-center gap-3 mb-6">
          <div className="h-10 w-10 rounded-md bg-orange-600 flex items-center justify-center"><Container className="h-5 w-5 text-white" /></div>
          <div className="font-heading font-extrabold tracking-wide text-xl uppercase">Reset password</div>
        </div>
        {sent ? (
          <div className="space-y-4">
            <p className="text-sm text-slate-300">
              A password reset link has been generated for <span className="text-orange-400">{email}</span>.
              For this environment the link is written to the backend logs (no email provider is connected).
            </p>
            <Link to="/login" className="inline-flex items-center gap-2 text-sm text-orange-400 hover:text-orange-300"><ArrowLeft className="h-4 w-4" /> Back to sign in</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <p className="text-sm text-slate-400">Enter your account email and we'll generate a reset link.</p>
            <input
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email"
              placeholder="you@company.com"
              className="w-full rounded-md bg-slate-950 border border-slate-700 px-3 py-2.5 text-sm text-slate-100 outline-none focus:border-orange-500"
            />
            <button type="submit" disabled={loading} data-testid="forgot-submit"
              className="w-full flex items-center justify-center gap-2 bg-orange-600 hover:bg-orange-500 disabled:opacity-60 text-white font-semibold px-4 py-2.5 rounded-md transition-all active:scale-[0.98]">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Mail className="h-4 w-4" />} Send reset link
            </button>
            <Link to="/login" className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-slate-200"><ArrowLeft className="h-4 w-4" /> Back to sign in</Link>
          </form>
        )}
      </div>
    </div>
  );
}
